import { createUseStyles, useDarkMode } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import styles from './GroupLabel.styles';

const useStyles = createUseStyles(styles);

const GroupLabel = ({ children }) => {
  const classes = useStyles();
  const dark = useDarkMode();

  return (
    <div data-qa="group-label" className={classnames(classes.root, { [classes.dark]: dark })}>
      {children}
    </div>
  );
};

GroupLabel.propTypes = { children: PropTypes.string };

GroupLabel.defaultProps = { children: '' };

export default GroupLabel;
